<template>
  <div :class="`task task-${color} ${body_class}`">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      state: {
        type: String,
        default: ''
      },
      body_class: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.state) {
          case 'disconnected': {
            return 'pending';
          }
          case 'pending': {
            return 'pending';
          }
          case 'processing': {
            return 'processing';
          }
          case 'dialing': {
            return 'dialing';
          }
          case 'connected': {
            return 'connected';
          }
          case 'active': {
            return 'active';
          }
          case 'busy': {
            return 'busy';
          }
          case 'ready': {
            return 'ready';
          }
          case 'busy-room': {
            return 'busy';
          }
          case 'ready-room': {
            return 'ready';
          }
          case 'pending-room': {
            return 'checking';
          }
          case 'empty-room': {
            return 'busy';
          }
          case 'checking': {
            return 'checking';
          }
          default: {
            return 'default';
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .ivu-poptip-rel {
    width: 140px;
  }
  .room-state {
    padding: 0.25rem 1rem;
    border-radius: 0px 0px 6px 0px;
  }
  .task {
    position: relative;
    border: #E5E5E5;
    &:before {
      content: '';
      display: block;
      position: absolute;
      left: -16px;
      top: 7px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
    &--state {
      border-radius: 100px;
      padding: 0.5em 1rem;
      margin-bottom: 10px;
    }
    &--middle {
      border-radius: 6px;
      padding: 0.5rem 1rem;
    }
    &-pending {
      background: $pending;
      border: 1px solid $border-pending;
    }
    &-processing {
      background: $processing;
    }
    &-dialing {
      background: $dialing;
    }
    &-connected {
      background: $connected;
    }
    &-active {
      background: $active;
    }
    &-ready {
      background: $connected;
    }
    &-busy {
      background: $active;
    }
    &-checking {
      background: $checking;
    }
  }
</style>